import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { BaseClient } from '../BaseClient';
export class SiteMediaFilesClientBase extends BaseClient {
  constructor() {
    super(...arguments);
    _defineProperty(this, "generateFileUploadUrlImpl", void 0);
  }
  async generateFileUploadUrl() {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      const {
        uploadUrl
      } = await this.request(this.generateFileUploadUrlImpl({
        mimeType: 'image/jpeg',
        fileName: 'image.jpg',
        filePath: '/_schedulingAssistant' // TODO: check if this is the correct path
      }), ...args);
      if (!uploadUrl) {
        throw new Error('failed to generate file upload url');
      }
      return uploadUrl;
    } catch (error) {
      this.logError('generateFileUploadUrl', 'Failed to generate file upload URL', {}, error);
      throw error;
    }
  }
  convertToEntity() {
    throw new Error('convertToEntity method should not be used in this context');
  }
  getServiceNameForLogs() {
    return 'SiteMediaFilesClient';
  }
}
//# sourceMappingURL=SiteMediaFilesClientBase.js.map